import React, { useState } from "react";
import useScrollDirection from "./useScrollDirection";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import Logo from "../images/logowebWhite.png";

function Header() {
  const [isNavOpen, setIsNavOpen] = useState(false);

  const scrollDirection = useScrollDirection();
  const navigate = useNavigate();
  const location = useLocation();

  const toggleNavbar = () => setIsNavOpen(!isNavOpen);


  const closeNavbar = () => {
    setIsNavOpen(false);
    const navbar = document.getElementById("navbarSupportedContent");
    if (navbar && navbar.classList.contains("show")) {
      navbar.classList.remove("show");
    }
  };


  const handleHomeClick = (e) => {
    e.preventDefault();
    closeNavbar();
    if (location.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/");
    }
  };

  const handleTestimonialsClick = (e) => {
    e.preventDefault();
    closeNavbar();

    if (location.pathname === "/") {
      // Already on home page → just scroll
      const section = document.getElementById("testimonials");
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      // Navigate to home page, then scroll after render
      navigate("/", { state: { scrollTo: "testimonials" } });
    }
  };

  const handleContactClick = (e) => {
    e.preventDefault();
    closeNavbar();

    if (location.pathname === "/") {
      // Already on home page → just scroll
      const section = document.getElementById("contact");
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      // Navigate to home page, then scroll after render
      navigate("/", { state: { scrollTo: "contact" } });
    }
  };

  /*const handleLoginClick = () => {
    window.location.href = 'https://login.yesedacademy.com';
  };*/
  return (
    <div className={`headerSticky ${scrollDirection === "down" ? "hide" : "show"}`}>
      <header className="header_section">
        <div className="header_top">
          <div className="container-fluid ">
            <nav className="navbar navbar-expand-lg custom_nav-container ">
              <a href="/" className="nav-link" onClick={handleHomeClick}> <img width="200px" alt="logo" src={Logo} /> </a>
              {/*<button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" >
          <span className> </span>
        </button>*/}
              <button
                className="navbar-toggler"
                type="button"
                aria-controls="navbarSupportedContent"
                aria-expanded={isNavOpen}
                aria-label="Toggle navigation"
                onClick={toggleNavbar}
              >
                {isNavOpen ? (
                  <i className="fa fa-times fa-lg text-white"></i> // close icon
                ) : (
                  <i className="fa fa-bars fa-lg text-white"></i> // hamburger icon
                )}
              </button>

              <div className={`collapse navbar-collapse ${isNavOpen ? "show" : ""}`} id="navbarSupportedContent">
                <ul className="navbar-nav  ">
                  <li className="nav-item">
                    <a
                      href="https://wa.me/918848288848" // ✅ WhatsApp link (international format)
                      target="_blank"
                      rel="noopener noreferrer"
                      className="contact_nav2 nav-link"
                      onClick={() => setIsNavOpen(false)} // closes menu
                    ><i className="fa fa-phone" aria-hidden="true"></i>&nbsp;+91 8848 28 8848</a>
                  </li>
                  <li className="nav-item active">
                    <a href="/" className="nav-link" onClick={handleHomeClick}>Home <span className="sr-only">(current)</span> </a>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/about" onClick={closeNavbar}> About</NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/services" onClick={closeNavbar}>Services</NavLink>
                  </li>
                  <li className="nav-item">
                    <a href="#testimonials" className="nav-link" onClick={handleTestimonialsClick}>Testimonials</a>
                  </li>
                  <li className="nav-item">
                    <a href="#contact" className="nav-link" onClick={handleContactClick}>Contact Us</a>
                  </li>
                  {/*<li className="nav-item">
            <NavLink className="nav-link" to="/login" onClick={handleLoginClick}><i className="fa fa-user" aria-hidden="true"></i>&nbsp;Login</NavLink>
  </li>*/}
                  {/*<li className="nav-item">
            <NavLink className="nav-link" to="/login"><i className="fa fa-user" aria-hidden="true"></i>Login</NavLink>
            </li>*/}
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </header>
    </div>


  );
}

export default Header;
